import { create } from 'zustand';
import { TOKEN_KEY, setOnUnauthorized } from '../api/client';
import type { Admin } from '../api/types';

type AuthState = {
  admin: Admin | null;
  token: string | null;
  setSession: (token: string, admin: Admin) => void;
  clear: () => void;
};

const stored = (() => {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { token } : null;
})();

export const useAuth = create<AuthState>((set) => ({
  admin: null,
  token: stored?.token ?? null,
  setSession: (token, admin) => {
    localStorage.setItem(TOKEN_KEY, token);
    set({ token, admin });
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    set({ token: null, admin: null });
  },
}));

// SHAR-1093/1094/1099 — a 401 from any request drops the in-memory session too.
setOnUnauthorized(() => useAuth.getState().clear());
